import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import BitcoinWalletHero from "./BitcoinWalletHero";
import BitcoinWalletDevSer from "./BitcoinWalletDevSer";
import MultiSignatureSupport from "./MultiSignatureSupport";
import Iterations from "./Iterations";
import CustomizableSolutions from "./CustomizableSolutions";
import WhyChoose from "../NFT Wallet/WhyChoose";

function BitcoinWallet() {
  return (
    <div>
      <Header />
      <BitcoinWalletHero />
      <BitcoinWalletDevSer />
      <MultiSignatureSupport />
      <Iterations />
      <WhyChoose />
      <Footer />
    </div>
  );
}

export default BitcoinWallet;
